export function PseudoRandom(seed: number) {
  seed = seed % 2147483647;
  return () => {
    seed = (seed * 16807) % 2147483647;
    return seed;
  };
}
